import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum TaxonomyTypes {
    PRODUCT_CATEGORY = 'productCategory',
    HANDOUT_EVENT_DEVIATION = 'handoutEventDeviation',
    TERMINATION_REASON = 'terminationReason',
    APPLICATION_PROGRESS_STATE = 'applicationProgressState',
    APPLICATION_REJECTION_REASON = 'applicationRejectionReason',
    COURSE_CANCELLATION_REASON = 'courseCancellationReason',
    COURSE_CANCELLATION_NOTICE = 'courseCancellationNotice',
    /** Abrechnungsgründe: reason of a free credit (Gutschrift ohne Rechnungsbezug) */
    BILLING_CREDIT_REASON = 'billingCreditReason',
    /** Abrechnungsgründe: reason of an invoice correction (storno + new invoice) */
    INVOICE_CORRECTION_REASON = 'invoiceCorrectionReason',
}

export namespace TaxonomyTypes {
    type Data = {
        text: string;
        description?: string;
    }

    export const Record: Record<TaxonomyTypes, Data> = {
        [TaxonomyTypes.PRODUCT_CATEGORY]: {
            text: 'Produktkategorie',
            description: 'Kategorie, die einem Produkt zugewiesen ist',
        },
        [TaxonomyTypes.HANDOUT_EVENT_DEVIATION]: {
            text: 'Abweichung Werbeaktion',
            description: 'Abweichung im Ablauf einer Werbeaktion',
        },
        [TaxonomyTypes.TERMINATION_REASON]: {
            text: 'Kündigungsgrund',
            description: 'Grund für die Kündigung eines Vertrags',
        },
        [TaxonomyTypes.APPLICATION_PROGRESS_STATE]: {
            text: 'Bewerbungsfortschritt',
            description: 'Substatus innerhalb des Bewerbungsprozesses',
        },
        [TaxonomyTypes.APPLICATION_REJECTION_REASON]: {
            text: 'Ablehnungsgrund Bewerbung',
            description: 'Grund, warum eine Bewerbung abgelehnt wurde',
        },
        [TaxonomyTypes.COURSE_CANCELLATION_REASON]: {
            text: 'Ausfallgrund',
            description: 'Grund, warum ein Kurstermin ausfällt',
        },
        [TaxonomyTypes.COURSE_CANCELLATION_NOTICE]: {
            text: 'Ausfallmeldung',
            description: 'Wie ein Kursausfall gemeldet wurde (z. B. rechtzeitig, kurzfristig, unentschuldigt)',
        },
        [TaxonomyTypes.BILLING_CREDIT_REASON]: {
            text: 'Gutschriftgrund',
            description: 'Abrechnungsgrund einer Gutschrift ohne Rechnungsbezug (z. B. Kulanz, Entschädigung)',
        },
        [TaxonomyTypes.INVOICE_CORRECTION_REASON]: {
            text: 'Korrekturgrund',
            description: 'Abrechnungsgrund einer Rechnungskorrektur (z. B. Geschwisterkind, falsches Produkt)',
        },
    }

    export const Items = mapRecordToItems(Record);
}
